import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const translations = {
  en: {
    // Hero
    greeting: 'Hey! I am',
    stats: [
      { value: '4+', label: 'Years of Experience' },
      { value: '20+', label: 'Projects Shipped' },
      { value: '100%', label: 'Passion for Design' },
    ],
    // Nav / toggle
    switchLang: '中文',
    // Experience
    experienceTitle: 'Experience',
    // Benefits
    benefitsTitle: 'What I Bring',
    // RecentWork
    recentWorkTitle: 'Recent Work',
    featured: 'Product Experience',
    allWork: 'Employment Experience',
    skills: 'Skills & Interests',
    // Home loading
    loading: 'Loading...',
  },
  zh: {
    // Hero
    greeting: '嗨！我是',
    stats: [
      { value: '4+', label: '年工作经验' },
      { value: '20+', label: '项目交付' },
      { value: '100%', label: '对设计的热情' },
    ],
    // Nav / toggle
    switchLang: 'English',
    // Experience
    experienceTitle: '工作经历',
    // Benefits
    benefitsTitle: '我能带来什么',
    // RecentWork
    recentWorkTitle: '近期作品',
    featured: '产品经历',
    allWork: '任职经历',
    skills: '兴趣特长',
    // Home loading
    loading: '加载中...',
  },
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState('zh');

  const toggleLang = () => setLang((prev) => (prev === 'en' ? 'zh' : 'en'));

  return (
    <LanguageContext.Provider value={{ lang, toggleLang, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}
